export enum MenuType {
    Manual = "manual",
    Silo = "silo",
  }